import {
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import { useAuth0 } from "@auth0/auth0-react";
import axios from "../../utils/axiosConfig";

export default function AdminInterests() {
  const { getAccessTokenSilently } = useAuth0();

  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [city, setCity] = useState("");
  const [survey, setSurvey] = useState("");
  const [expanded, setExpanded] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError("");

        const token =
          await getAccessTokenSilently({
            authorizationParams: {
              audience:
                "https://someet-api",
            },
          });

        const response = await axios.get(
          "/api/admin/event-interests",
          {
            headers: {
              Authorization:
                `Bearer ${token}`,
            },
          }
        );

        console.log(
          "ADMIN EVENT INTERESTS:",
          response.data
        );

        setItems(
          Array.isArray(response.data)
            ? response.data
            : []
        );
      } catch (err) {
        console.error(
          "ADMIN EVENT INTERESTS ERROR:",
          err.response?.status,
          err.response?.data,
          err
        );

        if (err.response?.status === 403) {
          setError(
            "Nie masz uprawnień do panelu administracyjnego."
          );
        } else if (
          err.response?.status === 401
        ) {
          setError(
            "Sesja wygasła. Zaloguj się ponownie."
          );
        } else {
          setError(
            "Nie udało się pobrać zainteresowanych."
          );
        }

        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [getAccessTokenSilently]);

  const cities = useMemo(
    () =>
      [
        ...new Set(
          items
            .map((item) => item.city)
            .filter(Boolean)
        ),
      ].sort(),
    [items]
  );

  const filtered = useMemo(() => {
    const text =
      search.trim().toLowerCase();

    return items.filter((item) => {
      const person = [
        item.firstname,
        item.surname,
        item.email,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      if (
        text &&
        !person.includes(text)
      ) {
        return false;
      }

      if (
        city &&
        item.city !== city
      ) {
        return false;
      }

      if (
        survey === "yes" &&
        !item.surveyFilled
      ) {
        return false;
      }

      if (
        survey === "no" &&
        item.surveyFilled
      ) {
        return false;
      }

      return true;
    });
  }, [
    items,
    search,
    city,
    survey,
  ]);

  if (loading) {
    return (
      <section>
        <p>Ładowanie zainteresowanych...</p>
      </section>
    );
  }

  if (error) {
    return (
      <section>
        <div className="admin-error">
          {error}
        </div>
      </section>
    );
  }

  return (
    <section>
      <div className="admin-filters">
        <input
          placeholder="Szukaj po osobie lub mailu"
          value={search}
          onChange={(e) =>
            setSearch(e.target.value)
          }
        />

        <select
          value={city}
          onChange={(e) =>
            setCity(e.target.value)
          }
        >
          <option value="">
            Wszystkie miasta
          </option>

          {cities.map((value) => (
            <option
              value={value}
              key={value}
            >
              {value}
            </option>
          ))}
        </select>

        <select
          value={survey}
          onChange={(e) =>
            setSurvey(e.target.value)
          }
        >
          <option value="">
            Wszystkie
          </option>

          <option value="yes">
            Ankieta wypełniona
          </option>

          <option value="no">
            Bez ankiety
          </option>
        </select>
      </div>

      <p className="admin-count">
        Wyników: {filtered.length}
      </p>

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Osoba</th>
              <th>Email</th>
              <th>Wiek</th>
              <th>Miasto</th>
              <th>Format</th>
              <th>Ankieta</th>
              <th />
            </tr>
          </thead>

          <tbody>
            {filtered.map((item) => (
              <Fragment key={item.id}>
                <tr>
                  <td>
                    {item.firstname || "-"}{" "}
                    {item.surname || ""}
                  </td>

                  <td>
                    {item.email || "-"}
                  </td>

                  <td>
                    {item.age ?? "-"}
                  </td>

                  <td>{item.city}</td>

                  <td>
                    {item.eventFormat}
                  </td>

                  <td>
                    {item.surveyFilled
                      ? "Tak"
                      : "Nie"}
                  </td>

                  <td>
                    <button
                      className="admin-small-button"
                      onClick={() =>
                        setExpanded(
                          expanded === item.id
                            ? null
                            : item.id
                        )
                      }
                    >
                      {expanded === item.id
                        ? "Ukryj"
                        : "Szczegóły"}
                    </button>
                  </td>
                </tr>

                {expanded === item.id && (
                  <tr className="admin-expanded">
                    <td colSpan="7">
                      <div className="admin-answer-grid">
                        <div>
                          <b>Motywacja</b>
                          <p>
                            {item.motivation ||
                              "Brak odpowiedzi"}
                          </p>
                        </div>

                        <div>
                          <b>
                            Czy była/był wcześniej?
                          </b>

                          <p>
                            {item.beenBefore ===
                            true
                              ? "Tak"
                              : item.beenBefore ===
                                  false
                                ? "Nie"
                                : "Brak odpowiedzi"}
                          </p>
                        </div>

                        <div>
                          <b>
                            Preferowane terminy
                          </b>

                          <p>
                            {item.preferredTimes
                              ?.length
                              ? item.preferredTimes.join(
                                  ", "
                                )
                              : "Brak odpowiedzi"}
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </Fragment>
            ))}

            {filtered.length === 0 && (
              <tr>
                <td
                  colSpan="7"
                  style={{
                    textAlign: "center",
                    padding: "2rem",
                  }}
                >
                  Brak zainteresowanych.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}